import React from 'react';

import { RenderProps } from './common-types';

export class Render<Args extends {}> extends React.Component<
  RenderProps<Args> & { args: Args }
> {
  render(): React.ReactNode {
    if (this.props.children) {
      if (typeof this.props.children === 'function') {
        return this.props.children(this.props.args);
      } else {
        return this.props.children;
      }
    }
  }
}
